import moment from 'moment';
import InviteNewCandidateService from "@/service/InviteNewCandidateService";
import JobAdsService from "@/service/JobAdsService";
import StaffService from "@/service/StaffService";
import SkillCertService from "@/service/SkillCertService";
import EmployTypeService from "@/service/EmployTypeService";
import AcademicService from "@/service/AcademicService";
import { StaffAcademic } from "@/model/StaffAcademic";
import { StaffJobHistory } from "@/model/StaffJobHistory";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import { CandidateInvited } from "@/model/CandidateInvited";
import { Attachment } from "@/model/Attachment";
import { StaffSkillCerts } from "@/model/StaffSkillCerts";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import DatePicker from "vue2-datepicker";
import jobApplicationValidatonObj from "./S090300-JobApplicationValidaton.js";
import Settings from '../../../constants/Settings.js';
var jobApplicationDataValidatonObj = new jobApplicationValidatonObj();

export default {
  name: "JobApplication",
  components: {
    DatePicker
  },
  mounted() {
    this.scrollContent();
    jobApplicationDataValidatonObj.jobApplicationValidaton();
    this.getAllMaritalStatus();
    this.getAllCandidateInvitedListByCandid();
    this.getCandidateInvitationDetail();
    this.getJobadListForCandidatesInvited();
    this.setMsg()
  },
  data: () => ({
    e1: 1,
    menuId: Settings.MenuID.JobApplicationForm,
    Settings: Settings,
    dictEnum: dictEnum,
    candidateInvited: new CandidateInvited(),
    candidateJobAdList: [],
    historyList: [],
    date: new Date(),
    min: new Date(),
    max: new Date(),
    type: 'date',
    isLoaded: true,
    jobName: "",
    time1: false,
    time2: false,
    time3: false,
    selectedDateTime1: false,
    selectedDateTime2: false,
    selectedDateTime3: false,
    optionList: [],
    userExist: false,
    existingUserId: '',
    attachment: new Attachment(),
    academicObj: {
      selectAll: false
    },
    staffAcademic: new StaffAcademic(),
    tempAcademicModel: new StaffAcademic(),
    maritalStatusList: [],
    academicList: [],
    isLoaded: true,
    isFromDate: true,
    isToDate: true,
    JobHistoryObj: {
      selectAll: false
    },
    employTypeList: [],
    staffJobHistory: new StaffJobHistory(),
    tempJobHistoryModel: new StaffJobHistory(),
    selectCandidateInvited: "",
    staffSkillCerts: new StaffSkillCerts(),
    IsAcademicLoaded: true,
    IsJobHistoryLoaded: true,
    jobAdList: [],
  }),
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    formattedDate() {
      return this.date &&
        moment(this.date).format('YYYY-MM-DD') != '1900-01-01'
        ? moment(this.date).format('YYYY-MM-DD')
        : undefined;
    },
  },
  methods: {
    async setMsg() {
      const lang = this.$store.getters[StoreGetter.candidatelLang] ? this.$store.getters[StoreGetter.candidatelLang] : 'TC';
      const res = await t.getMsg(lang);
      if (res.data.IsSuccess) {
        await this.$store.dispatch({
          type: `SysMsgStore/refreshStore`,
          payload: res.data.Data
        });
      } else {
        SweetAlertService.warning("Warn", res.data.Message);
      }
    },
    async getAllAcademics() {
      var self = this;
      const obj = {};
      const response = await AcademicService.getAllAcademics(obj);
      if (response.data.IsSuccess) {
        self.academicList = response.data.Data;
        if (self.candidateInvited.StaffModel.StaffAcademicList != null && self.candidateInvited.StaffModel.StaffAcademicList.length > 0) {
          var tempCode = 1;
          self.IsAcademicLoaded = false;
          self.candidateInvited.StaffModel.StaffAcademicList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.DateFrom = moment(String(element.DateFrom)).format("YYYY-MM-DD");
              element.DateTo = moment(String(element.DateTo)).format("YYYY-MM-DD");
              var academicDetail = self.academicList.find(
                (obj) => obj.AcademicCode == element.AcademicCode
              );
              element.AcademicDes =
                self.user.Lang == "EN"
                  ? academicDetail.EDesc
                  : academicDetail.CDesc;
              tempCode++;
            }
          );
          self.IsAcademicLoaded = true;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getAllMaritalStatus() {
      const obj = {};
      const response = await StaffService.getAllMaritalStatus(obj);
      if (response.data.IsSuccess) {
        this.maritalStatusList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    changeStep: function (no) {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (no == 2) {
            this.getAllAcademics();
          }
          if (no == 3) {
            //this.getAllSkillCertList();
          }
          if (no == 4) {
            this.getAllEmployType();
          }
          this.e1 = no;
        }
      });
    },
    scrollContent: function () {
      $(".body-scroll-area").mCustomScrollbar({
        theme: "dark",
        scrollInertia: 60,
        scrollbarPosition: "inside",
        axis: "y"
      });
    },
    async getAllCandidateInvitedListByCandid() {
      var self = this;
      const obj = {
        candId: this.$route.params.candId,
      };
      self.optionList = [];
      const response = await InviteNewCandidateService.getAllCandidateInvitedListByCandid(obj);
      if (response.data.IsSuccess) {
        self.candidateJobAdList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getJobadListForCandidatesInvited() {
      const obj = {};
      const response = await JobAdsService.getJobadListForCandidates(obj);
      if (response.data.IsSuccess) {
        this.jobAdList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getCandidateInvitationDetail() {
      var self = this;
      const obj = {
        staffId: this.$route.params.candId,
      };
      self.optionList = [];
      const response = await StaffService.getStaffDetail(obj);
      if (response.data.IsSuccess) {
        self.candidateInvited = new CandidateInvited();
        self.candidateInvited.StaffModel = response.data.Data;
        self.candidateInvited.StaffModel.SkillCertList = [];
        if (self.candidateInvited.StaffModel.StaffAttachmentList != null && self.candidateInvited.StaffModel.StaffAttachmentList.length > 0) {
          self.candidateInvited.StaffModel.StaffAttachmentList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
            });
        }
        self.candidateInvited.IsNew = false;
        self.getAllSkillCertList();
        self.getCandidateInvitedDetailByCandId();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getCandidateInvitedDetailByCandId() {
      var self = this;
      const obj = {
        candId: self.user.CandID,
        jobAdCode: self.user.JobAdCode,
        seq: self.user.Seq,
      };
      self.optionList = [];
      const response = await InviteNewCandidateService.getCandidateInvitedDetailByCandId(obj);
      if (response.data.IsSuccess) {
        var candidateInvited = response.data.Data;
        self.candidateInvited.JobAdCode = candidateInvited.JobAdCode;
        self.candidateInvited.Seq = candidateInvited.Seq;
        self.candidateInvited.CompanyEngName = candidateInvited.CompanyEngName;
        self.candidateInvited.CompanyChiName = candidateInvited.CompanyChiName;
        self.candidateInvited.JobName = candidateInvited.JobName;
        self.candidateInvited.Opt1Date = candidateInvited.Opt1 != '1900-01-01' ? candidateInvited.Opt1 : '';
        self.candidateInvited.Opt2Date = candidateInvited.Opt2 != '1900-01-01' ? candidateInvited.Opt2 : '';
        self.candidateInvited.Opt3Date = candidateInvited.Opt3 != '1900-01-01' ? candidateInvited.Opt3 : '';
        self.candidateInvited.Opt1Time = moment(candidateInvited.Opt1).format("HH:mm");
        self.candidateInvited.Opt2Time = moment(candidateInvited.Opt2).format("HH:mm");
        self.candidateInvited.Opt3Time = moment(candidateInvited.Opt3).format("HH:mm");
        if (self.candidateInvited.Opt1Date != "1900-01-01 00:00" && self.candidateInvited.Opt1Date != '') {
          var model = {
            IsSelected: false,
            Seq: 1,
            OptDate: moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt1Time,
            OptDateTime: moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time1"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt2Date != "1900-01-01 00:00" && self.candidateInvited.Opt2Date != '') {
          var model = {
            IsSelected: false,
            Seq: 2,
            OptDate: moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt2Time,
            OptDateTime: moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time2"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt3Date != "1900-01-01 00:00" && self.candidateInvited.Opt3Date != '') {
          var model = {
            IsSelected: false,
            Seq: 3,
            OptDate: moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt3Time,
            OptDateTime: moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time3"
          }
          self.optionList.push(model);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    resetInvitationData: function () {
      var self = this;
      self.optionList = [];
      self.candidateInvited = new CandidateInvited();
      self.$validator.reset();
      self.vErrors.clear();
    },
    onFileChange(payload) {
      var self = this;
      const reader = new FileReader();
      var file = payload; // in case vuetify file input
      reader.onload = (function (f) {
        return function (e) {
          var path = reader.result ? reader.result.toString() : "";
          self.candidateInvited.StaffModel.StaffAcademicList.forEach(element => {
            if (element.tempCode == self.tempAcademicModel.tempCode) {
              element.AcademicURL = path;
              element.AcademicFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
              element.DocMime = file.type;
              element.IsImageFile = path.indexOf("image") != -1 ? true : false;
            }
          });
        };
      })(file);
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    OnAddEmployeeAcademicButtonClick: function () {
      var self = this;
      self.academicObj.selectAll = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          var tempCode = 1;
          var seq = 1;
          self.candidateInvited.StaffModel.StaffAcademicList.forEach(element => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format("YYYY-MM-DD");
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format("YYYY-MM-DD");
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffAcademic = new StaffAcademic();
          staffAcademic.StaffID = self.candidateInvited.StaffModel.StaffID;
          staffAcademic.Seq = seq;
          staffAcademic.tempCode = tempCode;
          staffAcademic.IsEditMode = true;
          self.candidateInvited.StaffModel.StaffAcademicList.push(staffAcademic);
        }
      });
    },
    OnEmployeeAcademicDeleteClick: function (data) {
      var self = this;
      self.candidateInvited.StaffModel.StaffAcademicList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.candidateInvited.StaffModel.StaffAcademicList.splice(index, 1);
          return;
        }
      });
    },
    OnEmployeeAcademicSelection: function (item) {
      var self = this;
      self.tempAcademicModel = item;
      if (item.IsEditMode) {
        return;
      }
      self.IsAcademicLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.candidateInvited.StaffModel.StaffAcademicList.forEach(element => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format("YYYY-MM-DD");
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format("YYYY-MM-DD");
            }
            if (element.tempCode == item.tempCode) {
              self.IsAcademicLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsAcademicLoaded = true;
              element.IsEditMode = false;
            }
          });
        }
        self.IsAcademicLoaded = true;
      });
    },
    changeAcademic: function (item) {
      var self = this;
      var academicDetail = self.academicList.find(
        obj => obj.AcademicCode == item.AcademicCode
      );
      item.AcademicDes = self.user.Lang == 'EN' ? academicDetail.EDesc : academicDetail.CDesc;
    },
    OnAcademicImageOpen: function () {
      var self = this;
      $("#academicImage").click();
    },
    selectAllAcademicRecord: function () {
      var self = this;
      var IsSelected = self.academicObj.selectAll;
      self.candidateInvited.StaffModel.StaffAcademicList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeAcademicPopup: function () {
      var self = this;
      $('#deleteAcademic').modal('hide');
    },
    deleteMultipleAcademicPopup: function () {
      var arrayList = [];
      var self = this;
      self.candidateInvited.StaffModel.StaffAcademicList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteAcademic').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(self.academicDictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleAcademic: function () {
      var self = this;
      var staffAcademicList = self.candidateInvited.StaffModel.StaffAcademicList.filter(
        obj => obj.isSelected !== true
      );
      self.candidateInvited.StaffModel.StaffAcademicList = staffAcademicList;
      self.academicObj.selectAll = false;
      $('#deleteAcademic').modal('hide');
    },
    downloadFile: function (path) {
      var win = window.open();
      win.document.write('<iframe src="' + path + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    },
    OnCandidateImagePopupOpen: function () {
      $("#CandidatePhoto").click();
    },
    onPhotoChange(payload) {
      var self = this;
      var file = payload; // in case vuetify file input
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          var image = new Image();
          image.src = reader.result ? reader.result.toString() : "";
          image.onload = function () {
            var path = reader.result ? reader.result.toString() : "";
            self.candidateInvited.StaffModel.PhotoURL = path;
            self.candidateInvited.StaffModel.PhotoFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
          };
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    //Skills and certs
    async getAllSkillCertList() {
      var self = this;
      const obj = {};
      const response = await SkillCertService.getAllSkillCertList(obj);
      if (response.data.IsSuccess) {
        var skillCertList = response.data.Data;
        if (self.candidateInvited.StaffModel.StaffSkillCertsList != null && self.candidateInvited.StaffModel.StaffSkillCertsList.length > 0 && skillCertList != null && skillCertList.length > 0) {
          skillCertList.forEach((element) => {
            element.DateFrom = moment().format("YYYY-MM-DD");
            element.DateTo = moment().format("YYYY-MM-DD");
            if (element.ItemList != null && element.ItemList.length > 0) {
              element.ItemList.forEach((value) => {
                var staffSkillCertDetail = self.candidateInvited.StaffModel.StaffSkillCertsList.find((obj) => obj.SkillCate == value.SkillCate && obj.Item == value.Item && obj.Seq == value.Seq);
                if (staffSkillCertDetail != null && staffSkillCertDetail != undefined) {
                  if (staffSkillCertDetail.DateFrom != null && staffSkillCertDetail.DateFrom != "") {
                    value.DateFrom = moment(String(staffSkillCertDetail.DateFrom)).format("YYYY-MM-DD");
                  }
                  else {
                    value.DateFrom = '1900-01-01';
                  }
                  if (staffSkillCertDetail.DateTo != null && staffSkillCertDetail.DateTo != "") {
                    value.DateTo = moment(String(staffSkillCertDetail.DateTo)).format("YYYY-MM-DD");
                  }
                  else {
                    value.DateTo = '1900-01-01';
                  }
                  if (value.AnsType != 'CHK') {
                    value.Ans = staffSkillCertDetail.Ans;
                  }
                  else {
                    if (value.OptionCheckboxModelList != null && value.OptionCheckboxModelList.length > 0) {
                      var answerList = [];
                      if (staffSkillCertDetail.Ans.indexOf(',') != -1) {
                        answerList = staffSkillCertDetail.Ans.split(",");
                      }
                      value.OptionCheckboxModelList.forEach((optionCheckbox) => {
                        if (answerList.length > 0) {
                          var answerDetail = answerList.find((obj) => obj == optionCheckbox.Question);
                          if (answerDetail != null && answerDetail != undefined) {
                            optionCheckbox.Answer = true;
                          }
                        }
                        else {
                          if (optionCheckbox.Question == staffSkillCertDetail.Ans) {
                            optionCheckbox.Answer = true;
                          }
                        }
                      });
                    }
                  }
                }
                else {
                  value.DateFrom = moment().format("YYYY-MM-DD");
                  value.DateTo = moment().format("YYYY-MM-DD");
                }
              });
            }
          }
          );
          self.candidateInvited.StaffModel.SkillCertList = skillCertList;
        }
        else if (skillCertList != null && skillCertList.length > 0) {
          skillCertList.forEach((element) => {
            element.DateFrom = moment().format("YYYY-MM-DD");
            element.DateTo = moment().format("YYYY-MM-DD");
            if (element.ItemList != null && element.ItemList.length > 0) {
              element.ItemList.forEach((value) => {
                value.DateFrom = moment().format("YYYY-MM-DD");
                value.DateTo = moment().format("YYYY-MM-DD");
              });
            }
          }
          );
          self.candidateInvited.StaffModel.SkillCertList = skillCertList;
        }
        self.isLoaded = false;
        self.isLoaded = true;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    OnAttachmentOpen: function () {
      var self = this;
      $("#attachmentFile").click();
    },
    onAttachmentFileChange(e, fieldName, fileList) {
      var self = this;
      if (!fileList.length) return;
      var counter = -1, file;
      while (file = e.target.files[++counter]) {
        const reader = new FileReader();
        reader.onload = (function (file) {
          return function (e1) {
            var path = reader.result ? reader.result.toString() : "";
            self.staffAttachment = new Attachment();
            self.staffAttachment.DocURL = path;
            self.staffAttachment.DocFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
            self.staffAttachment.DocMime = file.type;
            self.staffAttachment.IsImageFile = path.indexOf("image") != -1 ? true : false;
            self.candidateInvited.StaffModel.StaffAttachmentList.push(self.staffAttachment);
          };
        })(file);
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    },
    deleteAttachmentPopup: function (data) {
      var self = this;
      self.selectedAttachment = new Attachment();
      self.selectedAttachment = data;
      $('#deleteAttachmentModal').modal('show');
    },
    OnAttachmentDeleteClick: function () {
      var self = this;
      self.candidateInvited.StaffModel.StaffAttachmentList.forEach((element, index) => {
        if (element.DocID == self.selectedAttachment.DocID) {
          self.candidateInvited.StaffModel.StaffAttachmentList.splice(index, 1);
          return;
        }
      });
      self.closeAttachmentPopup();
    },
    closeAttachmentPopup: function () {
      var self = this;
      self.selectedAttachment = new Attachment();
      $('#deleteAttachmentModal').modal('hide');
    },
    //Job History Module
    selectAllJobHistoryRecord: function () {
      var self = this;
      var IsSelected = self.JobHistoryObj.selectAll;
      self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    async getAllEmployType() {
      var self = this;
      const obj = {};
      const response = await EmployTypeService.getAllEmployTypes(obj);
      if (response.data.IsSuccess) {
        self.employTypeList = response.data.Data;
        if (self.candidateInvited.StaffModel.StaffJobHistoryList != null && self.candidateInvited.StaffModel.StaffJobHistoryList.length > 0) {
          var tempCode = 1;
          self.IsJobHistoryLoaded = false;
          self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(
            (element) => {
              if (element.DocMime != null && element.DocMime != "") {
                element.IsImageFile = element.DocMime.indexOf("image") != -1 ? true : false;
              }
              element.tempCode = tempCode;
              element.IsEditMode = false;
              element.DateJoin = moment(String(element.DateJoin)).format("YYYY-MM-DD");
              element.DateResign = moment(String(element.DateResign)).format("YYYY-MM-DD");
              var employTypeDetail = self.employTypeList.find(
                (obj) => obj.EmpType == element.EmpType
              );
              element.EmployTypeDes =
                self.user.Lang == "EN"
                  ? employTypeDetail.EDesc
                  : employTypeDetail.CDesc;
              tempCode++;
            }
          );
          self.IsJobHistoryLoaded = true;
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    OnAddEmployeeJobHistoryButtonClick: function () {
      var self = this;
      self.JobHistoryObj.selectAll = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          var tempCode = 1;
          var seq = 1;
          self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(element => {
            if (element.DateJoin != null && element.DateJoin != "") {
              element.DateJoin = moment(element.DateJoin).format("YYYY-MM-DD");
            }
            if (element.DateResign != null && element.DateResign != "") {
              element.DateResign = moment(element.DateResign).format("YYYY-MM-DD");
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffJobHistory = new StaffJobHistory();
          staffJobHistory.StaffID = self.candidateInvited.StaffModel.StaffID;
          staffJobHistory.Seq = seq;
          staffJobHistory.tempCode = tempCode;
          staffJobHistory.IsEditMode = true;
          self.candidateInvited.StaffModel.StaffJobHistoryList.push(staffJobHistory);
        }
      });
    },
    OnEmployeeJobHistoryDeleteClick: function (data) {
      var self = this;
      self.candidateInvited.StaffModel.StaffJobHistoryList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.candidateInvited.StaffModel.StaffJobHistoryList.splice(index, 1);
          return;
        }
      });
    },
    OnEmployeeJobHistorySelection: function (item) {
      var self = this;
      self.tempJobHistoryModel = item;
      if (item.IsEditMode) {
        return;
      }
      self.IsJobHistoryLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(element => {
            if (element.DateJoin != null && element.DateJoin != "") {
              element.DateJoin = moment(element.DateJoin).format("YYYY-MM-DD");
            }
            if (element.DateResign != null && element.DateResign != "") {
              element.DateResign = moment(element.DateResign).format("YYYY-MM-DD");
            }
            if (element.tempCode == item.tempCode) {
              self.IsJobHistoryLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsJobHistoryLoaded = true;
              element.IsEditMode = false;
            }
          });
        }
        self.IsJobHistoryLoaded = true;
      });
    },
    changeEmployType: function (item) {
      var self = this;
      var employTypeDetail = self.employTypeList.find(
        obj => obj.EmpType == item.EmpType
      );
      item.EmployTypeDes = self.user.Lang == 'EN' ? employTypeDetail.EDesc : employTypeDetail.CDesc;
    },
    onJobHistoryFileChange(payload) {
      var self = this;
      const reader = new FileReader();
      var file = payload; // in case vuetify file input
      reader.onload = (function (f) {
        return function (e) {
          var path = reader.result ? reader.result.toString() : "";
          self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(element => {
            if (element.tempCode == self.tempJobHistoryModel.tempCode) {
              element.JobHistoryURL = path;
              element.JobHistoryFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
              element.DocMime = file.type;
              element.IsImageFile = path.indexOf("image") != -1 ? true : false;
            }
          });
        };
      })(file);
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    OnJobHistoryImageOpen: function () {
      var self = this;
      $("#jobHistoryImage").click();
    },
    selectAllJobHistoryRecord: function () {
      var self = this;
      var IsSelected = self.JobHistoryObj.selectAll;
      self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeJobHistoryPopup: function () {
      var self = this;
      $('#deleteJobHistory').modal('hide');
    },
    deleteMultipleJobHistoryPopup: function () {
      var arrayList = [];
      var self = this;
      self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteJobHistory').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleJobHistory: function () {
      var self = this;
      var staffJobHistoryList = self.candidateInvited.StaffModel.StaffJobHistoryList.filter(
        obj => obj.isSelected !== true
      );
      self.candidateInvited.StaffModel.StaffJobHistoryList = staffJobHistoryList;
      self.JobHistoryObj.selectAll = false;
      $('#deleteJobHistory').modal('hide');
    },
    downloadJobHistoryFile: function (path) {
      var win = window.open();
      win.document.write('<iframe src="' + path + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    },
    //Interview Start Method
    changeJobPosition: function () {
      var self = this;
      if (self.selectCandidateInvited != '' && self.selectCandidateInvited.JobAdCode != undefined && self.selectCandidateInvited.JobAdCode != '' && self.selectCandidateInvited.JobAdCode != null) {
        self.optionList = [];
        self.candidateInvited.JobAdCode = self.selectCandidateInvited.JobAdCode;
        self.candidateInvited.Seq = self.selectCandidateInvited.Seq;
        self.candidateInvited.Opt1Date = self.selectCandidateInvited.Opt1 != '1900-01-01' ? self.selectCandidateInvited.Opt1 : '';
        self.candidateInvited.Opt2Date = self.selectCandidateInvited.Opt2 != '1900-01-01' ? self.selectCandidateInvited.Opt2 : '';
        self.candidateInvited.Opt3Date = self.selectCandidateInvited.Opt3 != '1900-01-01' ? self.selectCandidateInvited.Opt3 : '';
        self.candidateInvited.Opt1Time = moment(self.selectCandidateInvited.Opt1).format("HH:mm");
        self.candidateInvited.Opt2Time = moment(self.selectCandidateInvited.Opt2).format("HH:mm");
        self.candidateInvited.Opt3Time = moment(self.selectCandidateInvited.Opt3).format("HH:mm");

        if (self.candidateInvited.Opt1Date != "1900-01-01 00:00" && self.candidateInvited.Opt1Date != '') {
          var model = {
            IsSelected: false,
            Seq: 1,
            OptDate: moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt1Time,
            OptDateTime: moment(self.candidateInvited.Opt1Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time1"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt2Date != "1900-01-01 00:00" && self.candidateInvited.Opt2Date != '') {
          var model = {
            IsSelected: false,
            Seq: 2,
            OptDate: moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt2Time,
            OptDateTime: moment(self.candidateInvited.Opt2Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time2"
          }
          self.optionList.push(model);
        }
        if (self.candidateInvited.Opt3Date != "1900-01-01 00:00" && self.candidateInvited.Opt3Date != '') {
          var model = {
            IsSelected: false,
            Seq: 3,
            OptDate: moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD"),
            OptTime: self.candidateInvited.Opt3Time,
            OptDateTime: moment(self.candidateInvited.Opt3Date).format("YYYY-MM-DD HH:mm:ss"),
            time: false,
            ref: "time3"
          }
          self.optionList.push(model);
        }
      }
      else {
        self.optionList = [];
      }
    },
    submitJobApplicationPopup: function () {
      var self = this;
      var interviewSchDate = moment(self.candidateInvited.InterviewSch).format("YYYY-MM-DD");
      if (interviewSchDate != '1900-01-01' || self.candidateInvited.CallBack) {
        $('#submitJobApplication').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.t.t(dictEnum.WARN_SelectInterview));
      }
    },
    closeJobApplicationPopup: function () {
      var self = this;
      $('#submitJobApplication').modal('hide');
    },
    async saveJobApplicationData() {
      var self = this;
      $('#submitJobApplication').modal('hide');
      if (self.candidateInvited.StaffModel.StaffAcademicList.length > 0) {
        self.candidateInvited.StaffModel.StaffAcademicList.forEach(element => {
          element.StaffID = self.candidateInvited.StaffModel.StaffID;
          element.AddBy = self.$store.getters[StoreGetter.user].UserID;
          element.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
        });
      }
      if (self.candidateInvited.StaffModel.StaffJobHistoryList.length > 0) {
        self.candidateInvited.StaffModel.StaffJobHistoryList.forEach(element => {
          element.StaffID = self.candidateInvited.StaffModel.StaffID;
          element.AddBy = self.$store.getters[StoreGetter.user].UserID;
          element.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
        });
      }
      if (self.candidateInvited.StaffModel.SkillCertList.length > 0) {
        self.candidateInvited.StaffModel.StaffSkillCertsList = [];
        self.candidateInvited.StaffModel.SkillCertList.forEach(element => {
          if (element.ItemList != null && element.ItemList.length > 0) {
            element.ItemList.forEach((value) => {
              if (value.AnsType != 'CHK') {
                if (value.Ans != '') {
                  self.staffSkillCerts = new StaffSkillCerts();
                  self.staffSkillCerts.StaffID = self.candidateInvited.StaffModel.StaffID;
                  self.staffSkillCerts.SkillCate = value.SkillCate;
                  self.staffSkillCerts.Item = value.Item;
                  self.staffSkillCerts.Seq = Number(value.Seq);
                  self.staffSkillCerts.Ans = value.Ans;
                  if (value.DateFrom != null && value.DateFrom != "") {
                    self.staffSkillCerts.DateFrom = moment(String(value.DateFrom)).format("YYYY-MM-DD");
                  }
                  else {
                    self.staffSkillCerts.DateFrom = '1900-01-01';
                  }
                  if (value.DateTo != null && value.DateTo != "") {
                    self.staffSkillCerts.DateTo = moment(String(value.DateTo)).format("YYYY-MM-DD");
                  }
                  else {
                    self.staffSkillCerts.DateTo = '1900-01-01';
                  }
                  self.staffSkillCerts.AddBy = self.$store.getters[StoreGetter.user].UserID;
                  self.staffSkillCerts.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
                  self.candidateInvited.StaffModel.StaffSkillCertsList.push(self.staffSkillCerts);
                }
              }
              else {
                if (value.OptionCheckboxModelList != null && value.OptionCheckboxModelList.length > 0) {
                  var arrayList = [];
                  value.OptionCheckboxModelList.forEach((optionCheckboxDetail) => {
                    if (optionCheckboxDetail.Answer) {
                      arrayList.push(optionCheckboxDetail.Question);
                    }
                  });
                  if (arrayList.length > 1) {
                    value.Ans = arrayList.join(',');
                  }
                  else if (arrayList.length > 0) {
                    value.Ans = arrayList[0];
                  }
                  if (value.Ans != '') {
                    self.staffSkillCerts = new StaffSkillCerts();
                    self.staffSkillCerts.StaffID = self.candidateInvited.StaffModel.StaffID;
                    self.staffSkillCerts.SkillCate = value.SkillCate;
                    self.staffSkillCerts.Item = value.Item;
                    self.staffSkillCerts.Seq = Number(value.Seq);
                    self.staffSkillCerts.Ans = value.Ans;
                    if (value.DateFrom != null && value.DateFrom != "") {
                      self.staffSkillCerts.DateFrom = moment(String(value.DateFrom)).format("YYYY-MM-DD");
                    }
                    else {
                      self.staffSkillCerts.DateFrom = '1900-01-01';
                    }
                    if (value.DateTo != null && value.DateTo != "") {
                      self.staffSkillCerts.DateTo = moment(String(value.DateTo)).format("YYYY-MM-DD");
                    }
                    else {
                      self.staffSkillCerts.DateTo = '1900-01-01';
                    }
                    self.staffSkillCerts.AddBy = self.$store.getters[StoreGetter.user].UserID;
                    self.staffSkillCerts.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
                    self.candidateInvited.StaffModel.StaffSkillCertsList.push(self.staffSkillCerts);
                  }
                }
              }
            });
          }
        });
      }
      if (self.candidateInvited.StaffModel.StaffAttachmentList.length > 0) {
        self.candidateInvited.StaffModel.StaffAttachmentList.forEach(element => {
          element.DocType = 'SAC';
          element.StaffID = self.candidateInvited.StaffModel.StaffID;
          element.AddBy = self.$store.getters[StoreGetter.user].UserID;
        });
      }
      if (self.candidateInvited.StaffModel.DOB != null && self.candidateInvited.StaffModel.DOB != "") {
        self.candidateInvited.StaffModel.DOB = self.candidateInvited.StaffModel.DOB
          ? moment(self.candidateInvited.StaffModel.DOB).format("YYYY-MM-DD")
          : "1900-01-01";
      }
      self.candidateInvited.CandID = self.$route.params.candId;
      self.candidateInvited.StaffModel.ModifyBy = self.$store.getters[StoreGetter.user].UserID;
      self.candidateInvited.StaffModel.AddBy = self.$store.getters[StoreGetter.user].UserID;
      if (!self.candidateInvited.CallBack) {
        var interviewDate = moment(self.candidateInvited.InterviewSch).format("YYYY-MM-DD HH:mm");
        self.candidateInvited.InterviewSch = interviewDate;
      }
      var jobDetail = self.jobAdList.find(
        (obj) => obj.JobAdCode == self.candidateInvited.JobAdCode
      );
      self.candidateInvited.UserId = jobDetail.Interviewer;
      var obj = {
        model: self.candidateInvited,
      }
      self.saveJobApplication(obj);
    },
    async saveJobApplication(obj) {
      var self = this;
      const response = await InviteNewCandidateService.updateJobApplication(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", self.t.t(dictEnum.MSG_SuccessJobApplication));
        self.resetInvitationData();
        self.logout();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    logout: function () {
      const compCode = this.$store.getters[StoreGetter.user].CompCode;
      this.$store.dispatch({
        type: `AuthenticationStore/initUser`,
        payload: {}
      });
      this.$router.push(`/login/${compCode}`);
    },
    changeAcademicFormDate: function (item) {
      var self = this;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateFrom = moment().format("YYYY-MM-DD");
        return;
      }
    },
    changeAcademicToDate: function (item) {
      var self = this;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateTo = moment().format("YYYY-MM-DD");
        return;
      }
    },
    changeJobFormDate: function (item) {
      var self = this;
      if (new Date(item.DateJoin) > new Date(item.DateResign)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateJoin = moment().format("YYYY-MM-DD");
        return;
      }
    },
    changeJobToDate: function (item) {
      var self = this;
      if (new Date(item.DateJoin) > new Date(item.DateResign)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateResign = moment().format("YYYY-MM-DD");
        return;
      }
    },
    changeSkillCertFormDate: function (item) {
      var self = this;
      self.isFromDate = false;
      self.isFromDate = true;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateFrom = moment().format("YYYY-MM-DD");
        return;
      }
    },
    changeSkillCertToDate: function (item) {
      var self = this;
      self.isToDate = false;
      self.isToDate = true;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.t.t(self.dictEnum.MSG_DateCompare));
        item.DateTo = moment().format("YYYY-MM-DD");
        return;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S090000-Candidate/S090300-JobApplication/S090300-JobApplication.js